import styled, { css } from 'styled-components';
import { Button } from '@zocdoc-frontend-common/components-button';
import { UnstyledLink } from '@zocdoc-frontend-common/components-link';
import { SignInWithEmail } from '@zocdoc-frontend-common/components-sign-in-with-email';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { slate50, blue100, white } from '@zocdoc-mezzanine/foundations-colors';
import { paragraphSmall } from '@zocdoc-mezzanine/foundations-typography';
import { SignInForm } from '../../index';
import { StyledLoginButton as LoginButton } from '../../SignInFormView';

export const SocialLoginButtonWrapper = styled.div`
    margin-bottom: 8px;

    ${breakpoint.small} {
        margin-bottom: 12px;
    }
`;

export const SignupButton = styled(Button)`
    height: 48px;
`;

export const StandardLoginWrapper = styled.div`
    margin-top: 24px;
    margin-bottom: 24px;

    ${breakpoint.small} {
        margin-bottom: 0;
    }
`;

export const StandardLoginDividerText = styled.p`
    color: ${blue100};
    font: 16px/16px ${FontFamily.SharpSansSemibold};
    margin-bottom: 16px;
    text-align: center;
`;

export const StandardLoginTitle = styled.p`
    color: ${blue100};
    font: 18px/24px ${FontFamily.SharpSansBold};
    margin-bottom: 18px;
    text-align: center;
`;

export const StyledSignInForm = styled(SignInForm)`
    margin-bottom: 18px;

    ${(p) =>
        !p.$isInEmailFirstLoginAndSignup &&
        css`
            ${LoginButton} {
                background-color: ${'transparent'};
                color: ${blue100};

                &:hover {
                    background-color: ${blue100};
                    color: ${white};
                }
            }
        `};
`;

export const StyledSignInWithEmail = styled(SignInWithEmail)`
    margin-top: 28px;
`;

export const ForgotPasswordWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2px;
`;

export const ForgotPasswordLink = styled(UnstyledLink)`
    color: ${blue100};
    font: 14px/22px ${FontFamily.SharpSansSemibold};
    cursor: pointer;
    text-decoration: underline;
`;

export const DividerWrapper = styled.div`
    align-items: center;
    display: flex;
    margin: 20px 0;
`;

export const DividerText = styled.div`
    ${paragraphSmall};
    margin: 0 11px;
`;

export const DividerHorizontalLine = styled.div`
    border-bottom: 1px solid ${slate50};
    flex-grow: 1;
`;
